import { Spacing, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { SummaryLine } from '../SummaryLine/SummaryLine';
import { SummaryLineHeadersProps } from './SummaryLineHeaders.types';

export const SummaryLineHeaders = memo<SummaryLineHeadersProps>((props) => {
    const {
        value1,
        value2 = null,
        qa,
        color = 'midnight70',
        fontSize = 'small',
        fontWeight = 'medium',
        textAlign = 'right',
        ...restProps
    } = props;

    return (
        <>
            <SummaryLine
                {...restProps}
                value1={
                    <Text
                        font='label'
                        fontSize={fontSize}
                        fontWeight={fontWeight}
                        color={color}
                        textAlign={textAlign}
                        data-qa={qa}
                    >
                        {value1}
                    </Text>
                }
                value2={
                    value2 && (
                        <Text
                            font='label'
                            fontSize={fontSize}
                            fontWeight={fontWeight}
                            color={color}
                            textAlign={textAlign}
                            data-qa={qa}
                        >
                            {value2}
                        </Text>
                    )
                }
            />

            <Spacing height={8} />
        </>
    );
});

SummaryLineHeaders.displayName = 'SummaryLineHeaders';
